import React, { useState } from 'react';
import { IWizardItem } from '../WizardItem';
import WizardImage from '../WizardImage/WizardImage';
import WizardVideoThumbnail from './WizardVideoThumbnail';

interface Props {
	item: IWizardItem;
}

const WizardVideo: React.FC<Props> = ({ item }) => {
	const [showPlayer, setShowPlayer] = useState(false);

	if (!showPlayer && item.settings?.thumbnailUrl) {
		return (
			<WizardVideoThumbnail
				thumbnailUrl={item.settings?.thumbnailUrl}
				onClick={() => setShowPlayer(true)}
			/>
		);
	}

	if (item.settings?.url) {
		return (
			<iframe
				style={{ aspectRatio: '16/9', marginBottom: '50px' }}
				src={item.settings.url}
				width={'100%'}
				height={'auto'}
				frameBorder={'0'}
				allow={'autoplay; fullscreen'}
				allowFullScreen
			/>
		);
	}

	return <></>;
};

export default WizardVideo;
